/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'

import { getFirstEsClusterFromGet } from '@/lib/stackDeployments/selectors/fundamentals'
import { getStackDeployment } from '@/reducers/stackDeployments'

import { isFeatureActivated } from '../../selectors'
import { withStackDeploymentRouteParams } from '../StackDeploymentEditor'

import DeploymentOperations from './DeploymentOperations'

import type { ReduxState } from '@/types/redux'
import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (state: ReduxState, { stackDeploymentId }: ConsumerProps): StateProps => {
  const deployment = getStackDeployment(state, stackDeploymentId)!
  const esResource = getFirstEsClusterFromGet({ deployment })!

  return {
    deployment,
    resource: esResource,
    tempShieldUsersActivated: isFeatureActivated(state, Feature.tempShieldUsers),
  }
}

const mapDispatchToProps: DispatchProps = {}

export default withStackDeploymentRouteParams(
  connect(mapStateToProps, mapDispatchToProps)(DeploymentOperations),
)
